<template>
  <div class="borrower-fee-config">
    <div v-if="loading" class="loading-container">
      <a-spin size="large" />
    </div>
    <template v-else-if="feeConfig">
      <div class="fee-config-row">
        <div class="fee-config-item">
          <span class="label">{{ $t('investorList.fymc') }}:</span>
          <span class="value">{{ feeConfig.feeName }}</span>
        </div>
           <div class="fee-config-item">
          <span class="label">{{ $t('chargeNode') }}:</span>
          <span class="value"><Dict :dict-code="DICT_CODE.PLATFORMFEEPOINT" :value="String(feeConfig.feePoint)" /></span>
        </div>
        <div class="fee-config-item">
          <span class="label">{{ $t('chargeStandard') }}:</span>
          <span class="value">{{ feeConfig.feeDescription }}{{ feeConfig.feeDescription ? ' ' : '' }}{{ feeConfig.feeRate * 100 }}%</span>
        </div>
        <div class="fee-config-item">
          <span class="label">{{ $t('effectiveTime') }}:</span>
          <span class="value">{{ formatDateDisplay(feeConfig.updatedTime) }}</span>
        </div>
      </div>
    </template>
    <div v-else class="empty-container">
      <a-empty description="null" />
    </div>
  </div>
</template>

<script>
import { getProductConfigList, platformRevenueFlowList } from '@/webpublicapi/vietnamBackstage'
import Dict from '@/views/webpublic/modules/Dict'
import DICT_CODE from '@/constants/dict-code'

export default {
  name: 'BorrowerFeeConfiguration',
  components: { Dict },
  data() {
    return {
      DICT_CODE,
      loading: false,
      feeConfig: null,
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const [configRes, flowRes] = await Promise.all([
          getProductConfigList(),
          platformRevenueFlowList({ pageNum: 1, pageSize: 1 }),
        ])
        console.log('configRes:', JSON.stringify(configRes))
        console.log('flowRes:', JSON.stringify(flowRes))
        if (configRes && configRes.code === 1000 && configRes.data && configRes.data.length > 0) {
          const feeConfig = configRes.data[0]
          console.log('feeConfig from configRes:', JSON.stringify(feeConfig))
          // Get feePoint from platformRevenueFlowList
          if (flowRes && flowRes.code === 1000 && flowRes.data && flowRes.data.rows && flowRes.data.rows.length > 0) {
            feeConfig.feePoint = flowRes.data.rows[0].feePoint
            console.log('feePoint from flowRes:', feeConfig.feePoint)
          } else {
            console.log('flowRes has no rows, using feePoint from configRes:', feeConfig.feePoint)
          }
          this.feeConfig = feeConfig
        }
      } catch (error) {
        this.$message.error(this.$t('investorList.sb'))
      } finally {
        this.loading = false
      }
    },
    formatDateDisplay(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp)
      if (isNaN(date.getTime())) return timestamp

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';

.borrower-fee-config {
  background-color: #bde9c1;
  padding: 16px;
  border-radius: 4px;

  .loading-container,
  .empty-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100px;
  }

  .fee-config-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 90px;

    .fee-config-item {
      display: flex;
      align-items: center;
      gap: 8px;

      .label {
        font-size: 14px;
        color: #333;
      }

      .value {
        font-size: 14px;
        color: #666;
      }

    }
  }
}
</style>
